import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  notify_network_error() {
    Rails.fire(window, "ajax:error")
  }
}
